import { injectIntl } from 'react-intl';
import CheckoutErrorPage from './CheckoutErrorPage';

export default injectIntl(CheckoutErrorPage);
